import { render } from "./BorderItem.vue?vue&type=template&id=27c7f9dd"
import script from "./BorderItem.vue?vue&type=script&lang=js"
export * from "./BorderItem.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__